// extracted by mini-css-extract-plugin
export default {"customSwitch":"style_customSwitch__VOxQ8","switchLabel":"style_switchLabel__EAnO4"};